import * as React from 'react';
import { useNavigate } from 'react-router-dom';

import '../Main.scss';
import './BreadCrumbs.scss';

import {
    Tooltip
} from '@mui/material';

import {
    Button
} from 'reactstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
    faInfo,
} from '@awesome.me/kit-8a0d2fd588/icons/modules/sharp/light';

export type BreadCrumb = {
    content: string;
    link?: string;
    navCount?: number;
}

type Props = {
    containerStyling?: string;
    crumbs: BreadCrumb[];
    showInformation?: {
        active: boolean;
        tipTitle?: string;
        cancelTip: boolean;
        onInfoClick: (idTarget: string) => void;
    }
}

export const BreadCrumbs: React.FC<Props> = (props): React.ReactElement => {
    const {
        containerStyling,
        crumbs,
        showInformation
    } = props;

    const infoIconId = 'bread-crumbs-info-icon';

    const navigate = useNavigate();

    const [contentEmpty, setContentEmpty] = React.useState<boolean>(false);

    const InfoIconContent = React.useMemo(() => {
        if (!showInformation) {
            return (<></>);
        }
        return (
            <Button
                id={infoIconId}
                onClick={() => showInformation.onInfoClick(infoIconId)}
                color="secondary"
            >
                <FontAwesomeIcon icon={faInfo} />
            </Button>
        );

        // I want this to execute equivalent to componentDidMount so this is appropriate
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showInformation]);

    React.useEffect(() => {
        let empty = true;

        crumbs.forEach(crumb => {
            if (!!crumb.content) {
                empty = false;
            }
        });
        setContentEmpty(empty);
    }, [crumbs])

    const executeLink = (crumb: BreadCrumb): void => {
        if (!!crumb.link) {
            crumb.navCount !== undefined ? navigate(crumb!.navCount) : navigate(crumb.link || '')        
        }
    }

    if (contentEmpty) {
        return (<></>);
    } else {
        return (
            <div className={`crumb-container ${containerStyling}`}>
                {
                    crumbs.map((crumb, index) => {
                        return (index !== 0) ?
                            (
                                <div key={`breadcrumb${index}`}>
                                    &nbsp;&gt;&nbsp;
                                    <span
                                        className={!!crumb.link ? 'link' : 'disabled-link'}
                                        onClick={() => executeLink(crumb)}
                                    >
                                        {crumb.content}
                                    </span>
                                </div>
                            ) :
                            (
                                <div key={`breadcrumb${index}`}>
                                    <span
                                        className={!!crumb.link ? 'link' : 'disabled-link'}
                                        onClick={() => executeLink(crumb)}
                                    >
                                        {crumb.content}
                                    </span>
                                </div>
                            )
                    })
                }
                {
                    !!showInformation && showInformation.active && !!showInformation.tipTitle && (
                        <Tooltip title={showInformation.cancelTip ? '' : showInformation!.tipTitle}>
                            {InfoIconContent}
                        </Tooltip>
                    )
                }
                {
                    !!showInformation && showInformation.active && !showInformation.tipTitle && (
                        <>
                            {InfoIconContent}
                        </>
                    )
                }
            </div>
        );
    }
}
